export function isNullOrUndefined(val): boolean {
    return val == null || val == undefined;
}